module.exports = __webpack_public_path__ + "assets_app/img/header_keypad.6aa3fc12.svg";